import { FC } from "react";

import styles from "./styles.module.scss";

export const PatientStepsList: FC = ({ children }) => (
  <div className={styles.List}>{children}</div>
);
